import { render, staticRenderFns } from "./GlobalDocumentsPage.vue?vue&type=template&id=ab2ae360&scoped=true&"
import script from "./GlobalDocumentsPage.vue?vue&type=script&lang=js&"
export * from "./GlobalDocumentsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2ae360",
  null
  
)

export default component.exports